import React, { useEffect } from "react";

// Acuity redirects the embedded scheduler here after a booking completes.
// Being same-origin as the parent, this reliably signals the deposit step.
export const BookedRelay = () => {
  useEffect(() => {
    const inIframe = window.top !== window.self;
    if (inIframe) {
      // Inside the embedded scheduler → tell the parent page to advance seamlessly
      try {
        window.parent.postMessage({ event: "acuity_booking_confirmed" }, "*");
        window.top.postMessage({ event: "acuity_booking_confirmed" }, "*");
      } catch (_) {}
    } else {
      // Acuity redirected the whole page → go straight to the deposit step on the location page
      const slug = new URLSearchParams(window.location.search).get("slug") || "";
      if (slug) window.location.replace(`/${slug}?deposit=1`);
    }
  }, []);
  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-ivory">
      <p className="font-sans text-sm text-brand-muted">Appointment confirmed — taking you to the last step…</p>
    </div>
  );
};
